import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";

import { LoginService } from "app/services/login.service";
import { BeneficiarioService } from "app/services/beneficiario.service";
import { MatSnackBar } from '@angular/material/snack-bar';
import { PrestacionesService } from "../services/prestaciones.service";
import { Subscription, of, throwError } from "rxjs";
import { catchError, concatMap } from "rxjs/operators";
import { AuthDialogComponent } from "app/layout/components/auth-dialog/auth-dialog.component";
import { MatDialog } from "@angular/material/dialog";

@Component({
  selector: 'app-prestaciones-admin',
  templateUrl: './prestaciones-admin.component.html',
  styleUrls: ['./prestaciones-admin.component.scss']
})
export class PrestacionesAdminComponent implements OnInit {

  dataBreadcumbPages: Array<any> = [];
  dataBreadcumbTitle: any;
  getSessionDataGetSessionDataSuscription: Subscription;
  sessionId: any;
  data: any;
  cuilBenefSeleccionado: any;
  ordenBenefSeleccionado: any;
  nroBenefSeleccionado: any;
  nombreBenefSeleccionado: any;
  isDisabled: boolean = true;
  hasBenefit: boolean = true;
  prestaciones: any;
  columndefs: any = ['Prestacion', 'Prestador', 'Desde', 'Hasta', 'Sesiones', 'Accion'];
  loading: boolean = true;

  beneficiariosCuil: any = [];
  loadingBusquedaBenef: boolean = false;

  hasPrestacionesRechazadasAprobadas: boolean = false;
  hasPrestacionesEnviadas: boolean = false;
  listPrestacionesRechasadasAprobadas: any = [];
  prestacionesEnTransito: any;

  cuilBusqueda: number;
  beneficiarioSeleccionado: number = null;

  constructor(
    private router: Router,
    private getSessionData: LoginService,
    private beneficiarioService: BeneficiarioService,
    private prestacionesService: PrestacionesService,
    private dialog: MatDialog
  ) {
    this.dataBreadcumbPages = [{ page: 'Prestaciones Admin', route: '' }];
    this.dataBreadcumbTitle = [{ page: 'Discapacidad', route: '/index.php/discapacidad/page', externalUrl: true }];

    this.prestaciones = [];

  }
 
   
 
  ngOnInit(): void {

    const formData = new FormData();

    this.getSessionData
      .getSessionData()
      .subscribe(
      (result) => {

        if (result.session_id == null){
            this.dialog
            .open(AuthDialogComponent, {
              disableClose: true,
              panelClass: "custom-modalbox"
            })
            .afterClosed()
            .subscribe(() => (window.location.href = '/index.php/site/logout'));
        }

        const rolesPermitidos = ['ASEADM', 'ASEDIS', 'ASESAB'];
        if (!result['rol'] || !rolesPermitidos.includes(result['rol'])) {
          this.router.navigate(['/login']);
          return;
        }

        this.sessionId = result.session_id;

        // Cargar datos guardados
        const cuilGuardado = sessionStorage.getItem('cuilSeleccionado');
        const ordenGuardado = sessionStorage.getItem('ordenSeleccionado');
        
        if (cuilGuardado && ordenGuardado) {
            this.cuilBenefSeleccionado = cuilGuardado;
            this.cuilBusqueda = parseInt(cuilGuardado);
            this.ordenBenefSeleccionado = ordenGuardado;
            this.nroBenefSeleccionado = sessionStorage.getItem('nroBenefSeleccionado');
            this.nombreBenefSeleccionado = sessionStorage.getItem('nombreBenefSeleccionado');
            this.isDisabled = false;
            
            // Cargar también los beneficiarios para que aparezca el selector
            this.cargarBeneficiariosGuardados();
            // Cargar automáticamente las prestaciones
            this.cargarPrestacionesGuardadas();
        }
      });
  }

  setBenefData(event: any) {
    this.loading = true;
    
    // Usar directamente beneficiarioSeleccionado que ya viene del ngModel
    this.cuilBenefSeleccionado = this.beneficiariosCuil[this.beneficiarioSeleccionado].Cuil;
    this.ordenBenefSeleccionado = this.beneficiariosCuil[this.beneficiarioSeleccionado].Orden;
    this.nroBenefSeleccionado = this.beneficiariosCuil[this.beneficiarioSeleccionado].NroBeneficiario;
    this.nombreBenefSeleccionado = this.beneficiariosCuil[this.beneficiarioSeleccionado].NombreyApellido;
    this.isDisabled = false;

    // Guardar datos
    sessionStorage.setItem('cuilSeleccionado', this.cuilBenefSeleccionado);
    sessionStorage.setItem('ordenSeleccionado', this.ordenBenefSeleccionado);
    sessionStorage.setItem('nroBenefSeleccionado', this.nroBenefSeleccionado);
    sessionStorage.setItem('nombreBenefSeleccionado', this.nombreBenefSeleccionado);


    this.prestacionesService.getAllPrestaciones(this.sessionId, this.cuilBenefSeleccionado,  this.nroBenefSeleccionado, this.ordenBenefSeleccionado).pipe(
        catchError(error => throwError(error)),
        concatMap(
            (getAllResult) => { 
                if (getAllResult.length > 0) {
                    this.hasBenefit = false;
                } else {
                    this.hasBenefit = true;
                }
                
                this.prestaciones = getAllResult;
                
                return this.prestacionesService.getPrestaciones(this.sessionId, this.cuilBenefSeleccionado, this.nroBenefSeleccionado, this.ordenBenefSeleccionado).pipe(
                    catchError(error => {
                        return of(null); 
                    })
                );
            }
        ),
        concatMap(
            (getAprobRechResult) => { 
                if (getAprobRechResult.length > 0) {
                    this.hasPrestacionesRechazadasAprobadas = true;
                    this.listPrestacionesRechasadasAprobadas = getAprobRechResult;
                } else {
                    this.hasPrestacionesRechazadasAprobadas = false;
                }
                return this.prestacionesService.getPrestacionesEnTransito(this.sessionId, this.nroBenefSeleccionado, this.ordenBenefSeleccionado).pipe(
                    catchError(error => {
                        return of(null);
                    })
                );
            }
        )
    ).subscribe((getEnTransitoResult: any) => {
        if (getEnTransitoResult.length > 0) {
            this.hasPrestacionesEnviadas = true;
            this.prestacionesEnTransito = getEnTransitoResult;
        } else {
            this.hasPrestacionesEnviadas = false;
        }

        this.loading = false;
    });
  }
 
  onLoad() {
    this.loading = false;
  }

  goToPage() {
    if (this.cuilBenefSeleccionado && this.ordenBenefSeleccionado) {
      this.router.navigate([`discapacidad/prestaciones/nueva-prestacion`], { queryParams: { cuil: this.cuilBenefSeleccionado, orden: this.ordenBenefSeleccionado, nroBenef: this.nroBenefSeleccionado, nombreBenef: this.nombreBenefSeleccionado, prestacion:0 } });
    }
  }

  goToPageNewBenefit() {
    if (this.cuilBenefSeleccionado && this.ordenBenefSeleccionado) {
      this.router.navigate([`discapacidad/prestaciones/nueva-prestacion`], { queryParams: { cuil: this.cuilBenefSeleccionado, orden: this.ordenBenefSeleccionado, nroBenef: this.nroBenefSeleccionado, nombreBenef: this.nombreBenefSeleccionado, prestacion:1 } });
    }
  }

  busquedaBenefPorCuil() {
    console.log(this.cuilBusqueda);
    this.loadingBusquedaBenef = true;
    this.beneficiarioService.getPadronDataPorCuil(this.cuilBusqueda, this.sessionId).subscribe((result) => {
      this.beneficiariosCuil = result;
      console.log(this.beneficiariosCuil);
      this.loadingBusquedaBenef = false;
    });
  }
 
  cargarPrestacionesGuardadas() {
    console.log('entrando a cargarPrestacionesGuardadas');

    if (this.cuilBenefSeleccionado && this.sessionId) {
      this.loading = true;
      
      this.prestacionesService.getAllPrestaciones(this.sessionId, this.cuilBenefSeleccionado, this.nroBenefSeleccionado, this.ordenBenefSeleccionado).pipe(
          catchError(error => throwError(error)),
          concatMap(
              (getAllResult) => { 
                  if (getAllResult.length > 0) {
                      this.hasBenefit = false;
                  } else {
                      this.hasBenefit = true;
                  }
                  
                  this.prestaciones = getAllResult;
                  
                  return this.prestacionesService.getPrestaciones(this.sessionId, this.cuilBenefSeleccionado, this.nroBenefSeleccionado, this.ordenBenefSeleccionado).pipe(
                      catchError(error => {
                          return of(null); 
                      })
                  );
              }
          ),
          concatMap(
              (getAprobRechResult) => { 
                  if (getAprobRechResult.length > 0) {
                      this.hasPrestacionesRechazadasAprobadas = true;
                      this.listPrestacionesRechasadasAprobadas = getAprobRechResult;
                  } else {
                      this.hasPrestacionesRechazadasAprobadas = false;
                  }
                  return this.prestacionesService.getPrestacionesEnTransito(this.sessionId, this.nroBenefSeleccionado, this.ordenBenefSeleccionado).pipe(
                      catchError(error => {
                          return of(null);
                      })
                  );
              }
          )
      ).subscribe((getEnTransitoResult: any) => {
          if (getEnTransitoResult.length > 0) {
              this.hasPrestacionesEnviadas = true;
              this.prestacionesEnTransito = getEnTransitoResult;
          } else {
              this.hasPrestacionesEnviadas = false;
          }

          this.loading = false;
      });
    }
  }

  cargarBeneficiariosGuardados() {
    if (this.cuilBusqueda && this.sessionId) {
        this.loadingBusquedaBenef = true;
        this.beneficiarioService.getPadronDataPorCuil(this.cuilBusqueda, this.sessionId).subscribe((result) => {
            this.beneficiariosCuil = result;
            this.loadingBusquedaBenef = false;

            // Encontrar el índice del beneficiario guardado
            const index = this.beneficiariosCuil.findIndex(b => b.Cuil === this.cuilBenefSeleccionado);
            this.beneficiarioSeleccionado = index !== -1 ? index : null;
        });
    }
}

}
